// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"aff8e432","232":"3992674c","237":"4e4da19e","526":"bfb1337c","787":"1ed0c42c"}[chunkId] + ".chunk.js";
};